<style scoped>
.excel-span {
  height: 24px;
  line-height: 24px;
  display: inline-block;
  padding: 1px 8px 1px 8px;
  border-radius: 4px;
  background-color: #f4f4f5;
  font-size: 12px;
  color: #909399;
  margin-right: 8px;
}
</style>
<template>
  <div>
    <yi_curd_table v-show="false" :name="$options.name" v-bind="$attrs" ref="yt"> </yi_curd_table>
    <el-dialog :visible.sync="visible" :title="title" append-to-body="append-to-body">
      <div :class="[tableData.length > 0 ? 'dialog-scroller' : '']" style="display: flex;flex-direction: column;">
        <!--上传-->
        <div>
          <input id="mouldFileInput" ref="excel-upload-input" class="excel-upload-input" type="file" multiple accept=".xlsx, .xls" @change="handleClick" />
          <el-button :loading="yt.editObj.loading" size="mini" type="primary" icon="el-icon-document-add" @click="exportModel">
            {{ $t('xiazaimuban') }}
          </el-button>
          <el-button :loading="loadingBatch" size="mini" type="default" icon="el-icon-plus" @click="handleUpload">
            {{ $t('piliangshangchuan') }}
          </el-button>
        </div>
        <!--excel-->
        <div style="margin-top: 10px">
          <span v-for="(item, index) in excel" :key="index" class="excel-span" closable size="mini">
            <i class="el-icon-link" />
            <span>{{ item }}</span>
            <i style="margin-left: 5px" class="el-icon-close" @click="deleteExcel(item)" />
          </span>
        </div>
        <!--表格-->
        <div ref="table" style="flex: 1;margin-top: 10px;" v-loading="isLoading">
          <el-table border size="mini" :show-overflow-tooltip="true" :header-cell-style="{ background: '#F5F7FA', color: '#606266', 'font-weight': '700', height: '48px', padding: '0px' }" :stripe="true" :max-height="tableHeight" :data="tableData.slice((pagination.currentPage - 1) * pagination.pageSize, pagination.currentPage * pagination.pageSize)">
            <el-table-column v-for="(item, index) in tableColumn" :key="index" :prop="item.prop" :width="item.width" :label="item.label" :show-overflow-tooltip="true">
              <template slot-scope="scope">
                <span>{{ scope.row[item.prop] === '' ? '-' : scope.row[item.prop] }}</span>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div ref="pagination" style="padding-top: 10px;padding-bottom: 20px;">
          <el-pagination v-if="tableData.length > 0" style="margin-top: 5px; display: flex; float: right; flex-direction: row-reverse" background size="mini" :current-page="pagination.currentPage" :page-sizes="[10, 20, 100, 500]" :page-size="pagination.Z" layout="next, pager, prev, sizes , total" :total="tableData.length" @size-change="handleSizeChange" @current-change="handleCurrentChange" />
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button
          type="default"
          size="mini"
          style="margin-right: 10px;"
          @click="
            visible = false;
            clearColumn;
          "
        >
          {{ $t('quxiao') }}
        </el-button>
        <el-button :loading="loading" type="primary" size="mini" @click="importData">
          {{ $t('baocun') }}
        </el-button>
      </span>
      <!-- </div> -->
    </el-dialog>
  </div>
</template>

<script>
import XLSX from 'xlsx';

export default {
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  name: 'wms_material_inventory_import',
  data() {
    return {
      isLoading: false,
      loading: false,
      loadingBatch: false,
      excel: [],
      tableHeight: 0,
      tableData: [],
      tableColumn: [
        {
          label: this.$t('daorubaogao'),
          prop: 'results'
          // width: 300
        },
        {
          label: this.$t('dianjianfenzu'),
          prop: 'group',
          width: 180
        },
        {
          label: this.$t('shebeiSN'),
          prop: 'equipmentSn',
          width: 180
        }
      ],
      pagination: {
        currentPage: 1,
        pageSize: 10
      },
      visible: false,
      title: this.$t('daorudianjianfenzu-shebei')
    };
  },
  watch: {
    show: {
      handler(n) {
        this.visible = n;
        if (n == true) {
          this.countTableHeight();
        }
        if (n == false) {
          this.currentPage = 1;
        }
      },
      immediate: false
    },
    visible: {
      handler(n) {
        if (!n) {
          this.$emit('update:show', false);
          this.tableData = [];
          this.excel = [];
          this.$refs['excel-uploadl-input'].value = null;
        }
      },
      immediate: false
    }
  },
  methods: {
    countTableHeight() {
      this.tableHeight = 0;
      this.$nextTick(() => {
        if (this.tableData.length > 0) {
          this.tableHeight = this.$refs.table.offsetHeight - 10;
        } else {
          this.tableHeight = 110;
        }
      });
    },
    exportModel() {
      //下载模板
      window.open((process.env.NODE_ENV === 'development' ? global.URL_DEV_API_BASE_DOMAIN : process.env.VUE_APP_SERVER === 'preview' ? global.URL_PRE_API_BASE_DOMAIN : global.URL_PROD_API_BASE_DOMAIN) + '/web/customer/files/viewFileByFileId/shebeidianjianfenzushebeimuban');
    },
    importData() {
      this.loading = true;
      const data = [...this.tableData];
      if (data.length <= 0) {
        this.$message.error(this.$t('qingshangchuanwenjian'));
        setTimeout(() => {
          this.loading = false;
        }, 1000);
        return;
      }
      return this.http
        .post('/web/equipment/check/standard/importGroupAndEquipment?onlyValidate=false', data)
        .then(response => {
          //提示成功消息
          this.utils.successMessage(this.$t(response.msg));
          //关闭窗口
          this.show = false;
          setTimeout(() => {
            this.loading = false;
          }, 1000);
          // 刷新主页面列表
          this.utils.event_hub.$emit('EQUIPMENT_CHECK_STANDARD_GROUP_LIST');
        })
        .catch(error => {
          setTimeout(() => {
            this.loading = false;
          }, 1000);
          console.log('response:', error);
          //执行中出现问题,页面提示失败
          this.utils.errorMessage(this.$t(error));
        });
      setTimeout(() => {
        this.loading = false;
      }, 1000);
    },
    /**
     * 数据解析
     * @param header
     * @param results
     * @param name
     */
    generateData({ header, results, name }) {
      this.loadingBatch = true;
      const data = [];
      if (results.length > 0) {
        for (let i = 0; i < results.length; i++) {
          const item = {
            excel: name
          };
          for (let j = 0; j < this.tableColumn.length; j++) {
            if (results[i][this.tableColumn[j]['label']]) {
              this.$set(item, this.tableColumn[j]['prop'], results[i][this.tableColumn[j]['label']]);
            }
          }
          data.push(item);
        }
      }
      this.tableData = this.tableData.concat(data);
      this.excel.push(name);
      this.countTableHeight();
      this.loadingBatch = false;
    },
    /**
     * 显示上传弹框
     */
    handleUpload() {
      this.$refs['excel-upload-input'].click();
    },
    /**
     * 点击上传
     * @param e
     * @returns {Promise<void>}
     */
    handleClick(e) {
      this.isLoading = true;
      this.loadingBatch = true;
      const files = e.target.files;
      for (let i = 0; i < files.length; i++) {
        console.log(files[i]);
        this.beforeUpload(files[i]);
      }
      document.getElementById('mouldFileInput').value = '';
      setTimeout(() => {
        let data = [...this.tableData];
        this.http
          .post('/web/equipment/check/standard/importGroupAndEquipment?onlyValidate=true', data)
          .then(response => {
            if (response.msg === 'success') {
              this.isLoading = false;
            }
            const list = response.data.validateItems;
            if (list != undefined && list.length > 0) {
              const list2 = list;
              console.log('list', list.length);
              for (let i = 0; i < list2.length; i++) {
                console.log('index:', list2[i]['items'].join(','));
                this.$set(this.tableData[Number(list2[i]['index'])], 'results', list2[i]['items'].join(','));
              }
            }
            this.loadingBatch = false;
          })
          .catch(error => {
            this.utils.errorMessage(this.$t(error));
            setTimeout(() => {
              this.loadingBatch = false;
            }, 500);
            console.log('response', response);
          });
      }, 800);
    },
    /**
     * 上传前
     * @param rawFile
     * @returns {boolean}
     */
    beforeUpload(rawFile) {
      if (this.excel.length < 2) {
        //this.$refs['excel-upload-input'].value = null
      }
      if (!this.isExcel(rawFile)) {
        this.$message.error(this.$t('zhizhichi') + '.xlxs,xls,csv' + this.$t('geshiwenjian'));
        return false;
      }
      if (this.excel.length > 2) {
        this.$message.error(this.$t('zuidazhichi') + '3' + this.$t('geexcelwenjian'));
        return false;
      }
      if (this.excel.includes(rawFile.name)) {
        this.$message.error(rawFile.name + this.$t('wenjianyicunzai'));
        return false;
      }
      this.readerData(rawFile);
    },
    /**
     * 解析excel
     * @param rawFile
     */
    readerData(rawFile) {
      this.loadingBatch = true;
      const reader = new FileReader();
      reader.onload = e => {
        const name = rawFile.name;
        const data = e.target.result;
        const workbook = XLSX.read(data, {
          type: 'array'
        });
        const firstSheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[firstSheetName];
        const header = this.getHeaderRow(worksheet);
        const results = XLSX.utils.sheet_to_json(worksheet);
        this.generateData({
          header,
          results,
          name
        });
        this.loadingBatch = false;
      };
      reader.readAsArrayBuffer(rawFile);
    },
    /**
     * 获取excel头部
     * @param sheet
     * @returns {[]}
     */
    getHeaderRow(sheet) {
      const headers = [];
      const range = XLSX.utils.decode_range(sheet['!ref']);
      let C;
      const R = range.s.r;
      for (C = range.s.c; C <= range.e.c; ++C) {
        const cell =
          sheet[
            XLSX.utils.encode_cell({
              c: C,
              r: R
            })
          ];
        let hdr = 'UNKNOWN ' + C;
        if (cell && cell.t) hdr = XLSX.utils.format_cell(cell);
        headers.push(hdr);
      }
      return headers;
    },
    /**
     * 判断是否为excel文件
     * @param file
     * @returns {boolean}
     */
    isExcel(file) {
      return /\.(xlsx|xls|csv)$/.test(file.name);
    },
    /**
     * 页码
     * @param val
     */
    handleSizeChange(val) {
      this.pagination.pageSize = val;
      this.pagination.currentPage = 1;
    },
    /**
     * 分页
     * @param val
     */
    handleCurrentChange(val) {
      this.pagination.currentPage = val;
    },
    /**
     * 刪除excel
     * @param name
     */
    deleteExcel(name) {
      this.excel = this.excel.filter(item => {
        return item !== name;
      });
      this.tableData = this.tableData.filter(item => {
        return item.excel !== name;
      });
    }
  }
};
</script>

<style scoped>
.excel-upload-input {
  display: none;
  z-index: -9999;
}

.drop {
  border: 2px dashed #bbb;
  width: 600px;
  height: 160px;
  line-height: 160px;
  margin: 0 auto;
  font-size: 24px;
  border-radius: 5px;
  text-align: center;
  color: #bbb;
  position: relative;
}
</style>
